import { openDB } from 'idb';
import {IDBPDatabase} from "idb/build/entry";

const storageKey = 'storage';

let db: IDBPDatabase<unknown> | null = null;

openDB('drafts-db', 1, {
    upgrade(db) {
        db.createObjectStore(storageKey);
    },
}).then(database => db = database);

export default {
    async set(options: {key: string; value: string}): Promise<void> {
        await db?.put(storageKey, options.value, options.key);
    },
    async get(options: {key: string}): Promise<{value: string | null}> {
        return { value: await db?.get(storageKey, options.key) || null };
    }
}